class Marca{
    constructor(id, descripcion){
        this.id = id;
        this.descripcion = descripcion;
    }
}
export default Marca;